import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, connect, useSelector } from "react-redux";
import { AnimatePresence, motion } from "framer-motion";
import useQuery from "../../utils/useQuery";
// Components
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";
import LoginForm from "../../sections/login-form";
import BodyText from "../../elements/body-text";
import AccountPreviewCreateAccount from "../../react-components/account-preview-create-account";
// Styles
import "./style.scss";
// Animations
import { containerCartAnimations, childCartAnimations, checkoutAnimations } from "./animations";
import classNames from "classnames";
import { getToken, getUserInfo } from "../../services/userService";
import { S_AUTH_TOKEN, webStorage } from "../../utils/webStorage";
import { setUserInfoAction } from "../../redux/actions";
import useAccountLogin from "../../hooks/useAccountLogin";
import useCreateAccount from "../../hooks/useCreateAccount";
import { hideTrigger } from "../../redux/actions/actions";

// create an account section open
let submitting = false;
const AccountPreview = ({ lang, match, heading, body, active, loginForm, createAccountBox, createAccount, onAccountLogin, hideTrigger, onClickOutside = () => {} }) => {
  const query = useQuery();
  /*Redux Start*/
  const dispatch = useDispatch();

  // const user = useSelector(selectUserState);
  const setUserInfo = data => dispatch(setUserInfoAction(data));
  /*Redux End*/
  const [createAccountSection, setCreateAccountSectionState] = useState(false);
  const { loginFailed, loginWrongEmailOrPassword, loginNetworkError, loginAccountLock, temporaryLock, login } = useAccountLogin();
  const wrapperRoot = useRef(null);
  const wrapperLogin = useRef(null);
  const wrapperCreate = useRef(null);
  const [hasValue, setHasValue] = useState(false);

  const showCreateAccount = evt => {
    evt.preventDefault();
    if (!createAccountSection) {
      setCreateAccountSectionState(true);

      let newUrl = window?.location?.pathname + window?.location?.search?.replace("login", "create-account");
      window.history.pushState(null, null, newUrl);
    }
  };
  const submitLoginClick = async (evt, data) => {
    const res = await login(data.email, data.password);
    if (res?.userInfo) {
      /* Measurement */
      let dataLayer = window.dataLayer || [];

      let membershipLevel = "";

      switch (res?.userInfo.membershipCode) {
        case "MEMBERSHIP01":
          membershipLevel = "Level0";
          break;
        case "MEMBERSHIP02":
          membershipLevel = "Level1";
          break;
        case "MEMBERSHIP03":
          membershipLevel = "Level2";
          break;
        case "MEMBERSHIP04":
          membershipLevel = "Level3";
          break;
      }
      dataLayer.push({
        event: "accountLogin",
        eventCategory: "account",
        eventAction: "login",
        eventLabel: membershipLevel
      });
      onAccountLogin && onAccountLogin();
    }
  };

  useEffect(() => {
    if (!active) {
      setCreateAccountSectionState(false);
      document.body.style.overflowY = "auto";
    } else {
      document.body.style.overflowY = "hidden";
    }
  }, [active]);

  const createAccountProps = {
    ...createAccount,
    onLogined() {
      onAccountLogin && onAccountLogin();
    },
    valueToParent: value => setHasValue(value)
  };
  const handleClickOutside = event => {
    const target = event.target;
    const isWrapperClicked = wrapperRoot.current === target || wrapperRoot.current.contains(target);
    const passwordEye = classNames("password-toggle");
    const checkBox = "svg";

    if (hasValue === true) return;
    else if (!isWrapperClicked && event.target?.classList?.value !== passwordEye && event.target?.parentElement?.parentNode?.className !== passwordEye && event.target?.parentElement?.classList?.value !== passwordEye && event.target?.tagName !== checkBox) {
      onClickOutside();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, [hasValue]);

  useEffect(() => {
    hideTrigger(true);

    if (query && query?.show === "create-account") {
      setCreateAccountSectionState(true);
    }

    return () => {
      hideTrigger(false);
    };
  }, []);

  const containerClass = classNames("login-preview-container", {
    "visible-login": active && !createAccountSection
  });
  const containerCrateClass = classNames("login-preview-container", {
    "visible-create": active && createAccountSection
  });
  return (
    <div ref={wrapperRoot}>
      <AnimatePresence>
        <div className={containerClass} ref={active && !createAccountSection ? wrapperLogin : null} id="login">
          <motion.div
            className="login-preview"
            variants={containerCartAnimations}
            initial="exit"
            animate="enter"
            exit="exit"
            onClick={event => {
              // Prevent click in cart preview to call onClickOutside
              event.stopPropagation();
            }}
          >
            <motion.div className="animate" variants={childCartAnimations} exit="exit">
              <span className="close" onClick={onClickOutside}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                </svg>
              </span>
              <Heading {...heading} typographyClass="span" className="login-preview-heading" />
              {body && (
                <div
                  className="body-text"
                  dangerouslySetInnerHTML={{
                    __html: body
                  }}
                />
              )}
            </motion.div>

            <motion.div className="login-items" variants={childCartAnimations} exit="exit">
              <LoginForm
                {...{
                  ...loginForm,
                  formTitleBody: null,
                  description: null,
                  lang,
                  match,
                  loginFailed,
                  loginNetworkError,
                  loginAccountLock,
                  temporaryLock,
                  loginWrongEmailOrPassword,
                  submitLogin: (evt, data) => submitLoginClick(evt, data)
                }}
              />
            </motion.div>

            <motion.div variants={checkoutAnimations} exit="exit" className="animate">
              <div className="create-account-section">
                <div className="contnet-container">
                  <Heading
                    type={createAccountBox.createAccountBoxHeadingType}
                    className="login-preview-heading"
                    html={createAccountBox.createAccountBoxHeadingBody}
                    typographyClass={createAccountBox?.createAccountBoxHeadingtypographyClass ? createAccountBox?.createAccountBoxHeadingtypographyClass : "type-h3"}
                  />

                  {createAccountBox?.createAccountBoxbody?.value && <BodyText html={createAccountBox.createAccountBoxbody} className={"body-text"} />}

                  {createAccountBox.createAccount && <PrimaryButton {...createAccountBox.createAccount} callback={evt => showCreateAccount(evt)} />}
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>

        <div className={containerCrateClass} id="create" ref={active && createAccountSection ? wrapperCreate : null}>
          <motion.div
            className="login-preview"
            variants={containerCartAnimations}
            initial="exit"
            animate="enter"
            exit="exit"
            onClick={event => {
              // Prevent click in cart preview to call onClickOutside
              event.stopPropagation();
            }}
          >
            <motion.div className="animate" variants={childCartAnimations} exit="exit">
              <span className="close" onClick={onClickOutside}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                </svg>
              </span>
              <AccountPreviewCreateAccount {...createAccountProps} />
            </motion.div>
          </motion.div>
        </div>
      </AnimatePresence>
    </div>
  );
};

AccountPreview.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.string,
  active: PropTypes.bool,
  onClickOutside: PropTypes.func,
  onButtonClick: PropTypes.func,
  loginForm: PropTypes.object,
  createAccountBox: PropTypes.object,
  createAccount: PropTypes.object,
  submitLogin: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  hideTrigger: val => dispatch(hideTrigger(val)),
  dispatch
});

export default connect(null, mapDispatchToProps)(AccountPreview);
